<template>
  <v-app id="inspire">
    <v-main>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-card class="elevation-1">
              <v-toolbar :color="$vuetify.theme.dark ? 'light' : 'white'" flat>
                <v-toolbar-title> {{ $t("passwordRecovery.title") }}</v-toolbar-title>
                <div class="flex-grow-1"></div>
                <a :href="'//catalogs-parts.com/'+$i18n.locale+'/'">
                  <img
                    :src="require(`@/assets/logo.png`)"
                    height="40px"
                    width="51px"
                  />
                </a>
              </v-toolbar>

              <v-card-text>
                <v-form ref="passwordRecoveryForm" v-if="!showSuccessAlert">
                  <v-text-field
                    outlined
                    :disabled="isLoading"
                    autocomplete="email"
                    v-model="email"
                    :label="$t('passwordRecovery.email')"
                    id="phone"
                    validate-on-blur
                    :rules="[
                      (v) => !!v || $t('form.validationErrors.field_is_required'),
                      (v) =>
                        isValidEmail(v) || $t('form.validationErrors.email_not_valid'),
                    ]"
                    required
                    @keyup.enter="recovery"
                  ></v-text-field>
                  <v-divider class="mt-5"></v-divider>
                </v-form>
                <v-alert v-if="showSuccessAlert" color="success" outlined>
                  {{ $t("passwordRecovery.success_text") }}
                </v-alert>
              </v-card-text>
              <v-card-actions >
                <language-switcher class="mb-1" />
                <v-spacer></v-spacer>
                <v-btn
                  :disabled="isLoading"
                  :loading="isLoading"
                  elevation="0"
                  class="mb-2"
                  min-width="100"
                  color="primary"
                  to="/auth"
                >
                  {{ $t("form.login.title") }}
                </v-btn>
                <v-btn
                  :disabled="isLoading || showSuccessAlert"
                  :loading="isLoading"
                  elevation="0"
                  class="mb-2 mr-2"
                  min-width="100"
                  color="success"
                  @click="recovery"
                  @keyup.enter="recovery"
                >
                  {{ $t("passwordRecovery.recovery") }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import LanguageSwitcher from "../components/common/LanguageSwitcher";
import RegisterForm from "@/components/RegisterForm";
import isValidEmail from "@/utils/common";
export default {
  name: "PasswordRecovery",
  components: {RegisterForm, LanguageSwitcher },
  data: () => ({
    email: null,
    showSuccessAlert: false
  }),
  computed: {
    ...mapFields("auth", ["isLoading"]),
  },
  methods: {
    isValidEmail(email) {
      return isValidEmail(email)
    },
    recovery() {
      if (this.$refs['passwordRecoveryForm'].validate()) {
        this.$store.dispatch("auth/passwordRecovery", {'email':this.email}).then((result) => {
          if(result){
            this.showSuccessAlert = true;
          }
        });
      }

    },
  },
};
</script>
